import R from 'ramda'

const validBucketName =
  /(?=^.{3,63}$)(?!^(\\d+\\.)+\\d+$)(^(([a-z0-9]|[a-z0-9][a-z0-9\\-]*[a-z0-9])\\.)*([a-z0-9]|[a-z0-9][a-z0-9\\-]*[a-z0-9])$)/
const validIAMUserName = /^[\w+=,.@-]{1,64}$/
const validAccessKeyId = /^[\w]{16,128}$/

export const isValidS3BucketName: (bucketName: string) => boolean | string = R.ifElse(
  R.test(validBucketName),
  R.T,
  R.always('The bucket name is invalid.'),
)

export const isValidIAMUserName: (userName: string) => boolean | string = R.ifElse(
  R.test(validIAMUserName),
  R.T,
  R.always('The user name is invalid.'),
)

export const isValidAccessKeyId: (accessKey: string) => boolean = R.ifElse(
  R.test(validAccessKeyId),
  R.T,
  R.always('The access key is invalid.'),
)
